module.exports = __webpack_public_path__ + "static/media/icon_pulldown.371939cd.svg";